import { createContext } from 'react'

const AnnouncementsContext = createContext({
    announcements: [],
    popup: null,
    pollIntervalSeconds: null,
    popupOwnership: null,
    openPopup: () => {},
    closePopup: () => {},
    showBar: () => {},
    receiveAnnouncements: () => {},
    receiveSessionStart: () => {},
})

export default AnnouncementsContext
